
















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ProductCardContainer extends Vue {
  @Prop({ default: null }) readonly title!: string;
  @Prop({ default:null }) readonly image!: string;

}
